// Хелперы форматирования денежных сумм для ОСВ-гридов (свод/ОСВ по квартире).
//
// Проблема: при включённом чекбоксе «Свернуть дочерние помещения» числовые поля
// услуг (в т.ч. долг `end`) суммируются на фронте как JS number (float64).
// Например [0.03, -0.01, -0.01, -0.01] в двоичном float даёт -3.469446951953614e-18
// вместо чистого 0. Дефолтный форматтер MUI (value.toLocaleString()) и Intl.NumberFormat
// печатают такой микроостаток как «-0».
//
// Домен денег — 2 знака после запятой (как в excel-своде oci-docs, который тоже
// округляет до 2 знаков), поэтому сумму округляем до 2 знаков и снимаем артефакт «-0».

// Округляет денежную сумму до 2 знаков и нормализует отрицательный ноль/микроостаток float в чистый 0.
// Не-числа (null/undefined/NaN) трактуются как 0.
export const normalizeOsvMoney = (value: unknown): number => {
  if (typeof value !== 'number' || Number.isNaN(value)) return 0;
  const rounded = Math.round(value * 100) / 100;
  // rounded === 0 покрывает и -0, и микроостатки типа -3.47e-18 после округления → чистый 0
  return rounded === 0 ? 0 : rounded;
};

// Возвращает локализованную строку денежной суммы для ячеек ОСВ-грида.
// Сохраняет прежний вид реальных чисел (toLocaleString), но без артефакта «-0».
export const formatOsvMoney = (value: unknown): string => {
  if (typeof value !== 'number' || Number.isNaN(value)) return String(value ?? '');
  return normalizeOsvMoney(value).toLocaleString();
};
